<div class="tooltip_dialogbox">
  <div class="header_wrap">
    @if (!tooltipAutoShow) {
      <button mat-icon-button mat-dialog-close tabindex="-1">
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    }
    @if (titleTooltip) {
      <h2 class="title_42 text-center">
        {{ titleTooltip | translate }}
      </h2>
    }
  </div>
  @if (descTooltip) {
    <div class="desc_wrap" [innerHTML]="descTooltip | translate"></div>
    <div class="confirm-button-container">
      @if (confirmButtonTitle) {
        <h4>
          {{ confirmButtonTitle | translate }}
        </h4>
      }
      @if (tooltipAutoShow) {
        <app-button-outline-primary
          [title]="confirmButtonText"
          mat-dialog-close
          extraClasses="dialog_button"
          [isDisabled]="false"
        ></app-button-outline-primary>
      }
      @if (confirmButtonBottomText) {
        <h5>
          {{ confirmButtonBottomText | translate }}
        </h5>
      }
    </div>
  }

  @if (!!contentTemplateRef && !!!descTooltip) {
    <div
      ><ng-container *ngTemplateOutlet="contentTemplateRef"></ng-container
    ></div>
  }
</div>
